





























import { Vue, Component, Prop } from "vue-property-decorator";
import { Course as ICourse } from "@/api/models/course";

@Component
export default class Courses extends Vue {
  @Prop() courses!: Array<ICourse>;
}
